<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <div class="form-body">
        <div v-for="(row, rowIndex) in form.rows" :key="rowIndex">
            <form-header v-if="row.type === 'header'" :title="row.content.title"></form-header>
            <span v-if="row.type === 'row'">
                <div class="row">
                    <div v-for="(col, colIndex) in row.cols" :key="colIndex" class="col-md-6">
                        <text-input
                            v-if="col.type === 'text'"
                            v-model="form.entity[col.content.name]"
                            :name="col.content.name"
                            :errors="form.options.errors"
                            :title="col.content.title"
                        >
                        </text-input>
                        <checkbox
                            v-if="col.type === 'checkbox'"
                            v-model="form.entity[col.content.name]"
                            :name="col.content.name"
                            :checked="form.entity[col.content.name]"
                            :errors="form.options.errors"
                            :label="col.content.title"
                        >
                        </checkbox>
                        <multiselect
                            v-if="col.type === 'multiselect'"
                            v-model="form.entity[col.content.name]"
                            :name="col.content.name"
                            :errors="form.options.errors"
                            :checked="form.entity[col.content.selected]"
                            :options="form.options[col.content.name]"
                            :title="col.content.title"
                            :track-by="col.content.trackBy ? col.content.trackBy :  'id' "
                            :label="col.content.label ? col.content.label :  'name' "
                        >
                        </multiselect>

                         <singleselect
                             v-if="col.type === 'singleselect'"
                             v-model="form.entity[col.content.name]"
                             :name="col.content.name"
                             :errors="form.options.errors"
                             :options="form.options[col.content.name]"
                             :title="col.content.title"
                         >
                        </singleselect>
                        <text-input
                            v-if="col.type === 'tel'"
                            v-model="form.entity[col.content.name]"
                            v-mask="'+(##) ###-###-###'"
                            :name="col.content.name"
                            :errors="form.options.errors"
                            :title="col.content.title"
                            type="tel"
                        >
                        </text-input>
                    </div>
                </div>
            </span>
        </div>
    </div>
</template>

<script>
import TextInput from '../../component/dccore-form/textInput.vue'
import Multiselect from '../../component/dccore-form/multiselect.vue'
import Singleselect from '../../component/dccore-form/singleselect.vue'
import FormHeader from '../../component/dccore-form/formHeader.vue'
import Checkbox from '../../component/dccore-form/checkbox.vue'
import Vue from 'vue'
import VueMask from 'v-mask'
Vue.use(VueMask)

export default {
  components: {
    TextInput,
    FormHeader,
    Multiselect,
    Singleselect,
    Checkbox
  },
  props: {
    form: {
      type: Object,
      default: () => {},
    }
  },
}

</script>
